<template>
  <div style="display: inline-block;margin: 0 8px;">
    <el-select
      v-model="shop_id"
      placeholder="选择店铺"
      @change="handleShopChanged"
      :multiple='multiple'
      :collapse-tags='multiple'
      :style="{'width': widthF}"
      filterable
      clearable
      v-bind="$attrs"
    >
      <el-option
        v-for="item in shopList"
        :key="item.shop_id"
        :label="`${item.shop_name} - ( ${item.company_name} )`"
        :value="item.shop_id"/>
    </el-select>
  </div>
</template>

<script>
import * as API_Shop from '@/api/shop'

export default {
  name: 'EnShopSelector',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    allChecked: {
      type: Boolean,
      default: false
    },
    widthF: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      shop_id: '',
      shopList: []
    }
  },
  watch: {
    allChecked(newVal) {
      console.log(newVal, '');
      if (newVal) {
        this.shop_id = this.shopList.map(d => d.shop_id)
        this.handleShopChanged()
      } else {
        this.shop_id = []
        this.handleShopChanged()
      }
    }
  },
  created() {
    API_Shop.getAllShopList().then(response => {
      this.shopList = response
      if (this.allChecked) {
        this.shop_id = response.map(d => d.shop_id)
        this.handleShopChanged()
      }
    })
  },
  methods: {
    handleShopChanged() {
      if (this.shop_id instanceof Array) {
        let shop = this.shop_id
        this.$emit('changed', shop)
      } else {
        const shop = this.shopList.filter(item => item.shop_id === this.shop_id)
        this.$emit('changed', shop[0] || {shop_id: 0, shop_name: '全平台'})
      }
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>
